import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { darken } from '@/(routers)/boards/editor/block/blockTheme';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'continue',
    colour: darken(CATEGORIES.control.color),
    tooltip: '次のループに進みます',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('CONTINUE', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                { type: 'label', text: 'くりかえしの先頭にもどる ' },
            ],
        },
    ],
});
